import type { NovoCliente } from '@pgcustom/shared-types';

/**
 * Monta o payload de `POST /clientes` a partir dos valores digitados no
 * formulário. Campos opcionais só entram quando preenchidos —
 * `criarClienteSchema` (backend, `apps/api/src/modules/clientes/clientes.schema.ts`)
 * aceita `string | undefined` para email/cpf/telefone, nunca `null`
 * (diferente do schema de atualização, que é `nullable` de propósito,
 * para permitir apagar um campo já existente). Enviar `null` aqui faria
 * o backend rejeitar com 400 mesmo um cadastro válido sem contato.
 *
 * Função pura, sem dependência de DOM — separada de
 * `cliente-form-modal.ts` (que estende `HTMLElement`) de propósito, para
 * poder ser testada no ambiente `node` do vitest, mesmo motivo de
 * `normalizarHash`/`encontrarRota` viverem fora da classe `Router` em
 * `core/router.ts`.
 */
export function construirPayloadCriarCliente(
  nome: string,
  email: string,
  cpf: string,
  telefone: string
): NovoCliente {
  const dado: NovoCliente = { nome };
  if (email) dado.email = email;
  if (cpf) dado.cpf = cpf;
  if (telefone) dado.telefone = telefone;
  return dado;
}
